module.exports = __webpack_public_path__ + "img/introduction.4274aade.png";